// Compliance library language: keep the wording as approved.
export const MYGA_AGENCY_DISCLOSURE =
  "Goldfinch is a licensed insurance agency.";
export const MYGA_GUARANTEE_DISCLOSURE =
  "Guarantees are subject to the contract terms and the issuing insurer’s claims-paying ability.";
export const MYGA_ISSUANCE_DISCLOSURE =
  "Issuance is subject to carrier acceptance and applicable eligibility requirements.";
export const MYGA_AVAILABILITY_DISCLOSURE =
  "Availability may vary by state, carrier, product, premium amount, term, and other eligibility requirements.";
export const MYGA_RATING_DISCLOSURE =
  "Financial-strength ratings reflect an insurer’s claims-paying ability and are subject to change.";
